"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityListResponseSchema = exports.activityListQuerySchema = exports.activitySchema = exports.activityMetadataSchema = exports.activityActorTypeSchema = exports.activityEntityTypeSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.activityEntityTypeSchema = zod_1.z.enum([
    "JOB",
    "APPOINTMENT",
    "ATTACHMENT",
    "ESTIMATE",
]);
exports.activityActorTypeSchema = zod_1.z.enum(["STAFF", "CUSTOMER", "SYSTEM"]);
exports.activityMetadataSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown());
exports.activitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    entityType: exports.activityEntityTypeSchema,
    entityId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid().nullable(),
    jobId: zod_1.z.string().uuid().nullable(),
    actor: zod_1.z.object({
        type: exports.activityActorTypeSchema,
        membershipId: zod_1.z.string().uuid().nullable(),
        name: zod_1.z.string().nullable(),
    }),
    title: zod_1.z.string().min(1).max(240),
    metadata: exports.activityMetadataSchema,
    occurredAt: zod_1.z.string().datetime({ offset: true }),
    deepLink: zod_1.z.string().regex(/^\/(?!\/)/),
});
exports.activityListQuerySchema = pagination_1.paginationQuerySchema;
exports.activityListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.activitySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
//# sourceMappingURL=activity.js.map